
import React, { Component } from 'react';
//import Holder from 'holderjs'
import Carousel from 'react-bootstrap/Carousel';


//import logs2 from '../assets/images/maciej-rusek-269516-unsplash.png';
//require('holderjs')

class AboutMe extends Component {
    constructor(props, context) {
        super(props, context);
    
        this.handleSelect = this.handleSelect.bind(this);

        this.state = {
          index: 0,
          direction: null,
        };
      }
    
      handleSelect(selectedIndex, e) {
        if (e) {
            this.setState({
                index: selectedIndex,
                direction: e.direction,
            });
        } else {
            this.setState({
                index: selectedIndex,
            });
        }
      }
    
      render() {
        const { index, direction } = this.state;

        return(
            <Carousel  className="aboutMeItemBackgroundImage"
            activeIndex={index}
            direction={direction}
            onSelect={this.handleSelect}
          >
            <Carousel.Item className="aboutMeItem">
                <blockquote className="aboutMeCards">
                <h1>I love to build things</h1>
                </blockquote>
            </Carousel.Item>
            
            <Carousel.Item className="aboutMeItem">
                <blockquote className="aboutMeCards">
                <h1>Like this website which is under construction</h1>
                </blockquote>

                
            </Carousel.Item>
            

            <Carousel.Item className="aboutMeItem">
                <blockquote className="aboutMeCards">
                <h1>Come back for updates ! :)</h1>
                </blockquote>

            </Carousel.Item>
          </Carousel>
        );     
    }

}

export default AboutMe;